import { createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import { decryptRole } from "App";
import ApiClient from "helpers/ApiClient";
import { getToken } from "helpers/Tokens";

const initialState: any = {
  employeeList: [],
  loading:false
};

export const getEmployeesData:any = createAsyncThunk<any>(
  "getEmployeesData/setEmployeesData",
  async (_, thunkAPI) => {
    try {
      let userData= getToken();
      const corporateRole = decryptRole(userData?.role)==='Corporate'
      const response = await ApiClient.get(corporateRole ? `employee-management?limit=1000`:`customer-management?companyId=${'6385bbab396511c3c5aaca79'}&limit=1000`);
      return corporateRole ? response?.data?.employees?.data : response?.data?.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

const employeeSlice = createSlice({
  name: "getEmployeesData",
  initialState,
  reducers: {
    setEmployeesData(state, action) {
      state.employeeList = action.payload;
    },
  },
  extraReducers: {
    [getEmployeesData.pending]: (state:any) => {
      state.loading = true
    },
    [getEmployeesData.fulfilled]: (state:any, action: any) => {
      state.loading = false
      state.employeeList = action.payload;
    },
    [getEmployeesData.rejected]: (state:any) => {
      state.loading = false
    },
  },
});

export const { setEmployeesData } = employeeSlice.actions;
export default employeeSlice;
